import { render, staticRenderFns } from "./PublicBreadcrumb.vue?vue&type=template&id=4c128373&scoped=true&"
import script from "./PublicBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./PublicBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./PublicBreadcrumb.vue?vue&type=style&index=0&id=4c128373&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c128373",
  null
  
)

export default component.exports